module.exports = __webpack_public_path__ + "static/media/bubble-lines4.eaddc5e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/bubble-lines4.svg
// module id = 2475
// module chunks = 7